import { Router } from 'express';
import { PromptService } from '../services/prompt-service.js';
import { ApiError } from '../types.js';

export const promptRouter = Router();
const promptService = new PromptService();

// 获取所有 Prompt
promptRouter.get('/', async (req, res, next) => {
  try {
    const prompts = await promptService.list();
    res.success(prompts);
  } catch (error) {
    next(error);
  }
});

// 获取单个 Prompt
promptRouter.get('/:id', async (req, res, next) => {
  try {
    const prompt = await promptService.get(req.params.id);
    if (!prompt) {
      throw new ApiError(404, 'Prompt not found');
    }
    res.success(prompt);
  } catch (error) {
    next(error);
  }
});

// 创建 Prompt
promptRouter.post('/', async (req, res, next) => {
  try {
    const { name, description, category, content, variables } = req.body;
    
    if (!name || !description || !category || !content) {
      throw new ApiError(400, 'Name, description, category and content are required');
    }

    const prompt = await promptService.create({
      name,
      description,
      category,
      content,
      variables: variables || [],
      tags: req.body.tags || [],
      author: req.body.author || '@user',
      version: req.body.version || '1.0.0',
      isPublic: req.body.isPublic !== false,
      rating: req.body.rating,
      examples: req.body.examples
    });
    
    res.created(prompt);
  } catch (error) {
    if (error instanceof Error && error.message === 'Prompt 名称已存在') {
      next(new ApiError(409, error.message));
    } else {
      next(error);
    }
  }
});

// 更新 Prompt
promptRouter.put('/:id', async (req, res, next) => {
  try {
    const updates = req.body;
    const prompt = await promptService.update(req.params.id, updates);
    res.success(prompt);
  } catch (error) {
    if (error instanceof Error) {
      if (error.message === 'Prompt 不存在') {
        next(new ApiError(404, error.message));
      } else if (error.message === 'Prompt 名称已存在') {
        next(new ApiError(409, error.message));
      } else {
        next(error);
      }
    } else {
      next(error);
    }
  }
});

// 删除 Prompt
promptRouter.delete('/:id', async (req, res, next) => {
  try {
    await promptService.delete(req.params.id);
    res.deleted();
  } catch (error) {
    if (error instanceof Error && error.message === 'Prompt 不存在') {
      next(new ApiError(404, error.message));
    } else {
      next(error);
    }
  }
});

// 增加使用次数
promptRouter.post('/:id/use', async (req, res, next) => {
  try {
    await promptService.incrementUsage(req.params.id);
    res.success({ message: 'Usage count incremented' });
  } catch (error) {
    next(error);
  }
});

// 评分
promptRouter.post('/:id/rate', async (req, res, next) => {
  try {
    const { rating } = req.body;
    
    if (!rating || typeof rating !== 'number') {
      throw new ApiError(400, 'Rating is required and must be a number');
    }
    
    await promptService.rate(req.params.id, rating);
    res.success({ message: 'Rating updated' });
  } catch (error) {
    if (error instanceof Error && error.message === '评分必须在 1-5 之间') {
      next(new ApiError(400, error.message));
    } else {
      next(error);
    }
  }
});